import { jsx, css } from '@emotion/react';

const dividerStyles = css`
  border-top: 2px solid #000;
  margin: 40px 0;

  @media (min-width: 1200px) {
    margin: 72px 0;
  }
`;

const Divider = () => <div css={dividerStyles} />;

export default Divider;
